import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronDown, Menu, X } from "lucide-react";

const navItems = [
  { label: "Platform", href: "/platform/" },
  { label: "AI Governance", href: "/ai-governance/" },
  { label: "Modules", href: "/modules/" },
  { label: "Pricing", href: "/pricing/" },
  { label: "Compare", href: "/compare/" },
  { label: "Switch", href: "/switch/" },
  { label: "Partners", href: "/partners/" },
  { label: "Toolkits", href: "/toolkits/" },
  { label: "Blog", href: "/blog/" },
  { label: "About", href: "/about/" },
  { label: "Contact", href: "/contact/" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 surface-elevated border-b border-border/60 backdrop-blur-md bg-background/90">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-semibold text-lg tracking-tight">
          <div className="h-8 w-8 rounded-lg gradient-cta flex items-center justify-center">
            <span className="text-primary-foreground text-sm font-bold">P</span>
          </div>
          <span>Privacy360</span>
        </Link>

        <div className="flex items-center gap-2 lg:gap-4">
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) =>
              item.href === "/about/" ? (
                <div key={item.href} className="group relative">
                  <Link
                    to={item.href}
                    className={`flex items-center gap-1 whitespace-nowrap px-2.5 py-2 text-sm font-medium rounded-md transition-colors hover:bg-secondary ${
                      location.pathname.replace(/\/?$/, "/") === item.href ? "text-primary" : "text-secondary"
                    }`}
                  >
                    {item.label}
                    <ChevronDown className="h-3.5 w-3.5" />
                  </Link>
                  <div className="invisible absolute left-0 top-full z-50 min-w-[180px] pt-1 opacity-0 transition-opacity group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
                    <div className="rounded-md border border-border/60 bg-popover p-1 shadow-lg">
                      <Link to="/about/" className="block rounded px-3 py-2 text-sm text-secondary hover:bg-secondary">About Privacy360</Link>
                      <a href="https://formiti.com" className="block rounded px-3 py-2 text-sm text-secondary hover:bg-secondary">Formiti</a>
                    </div>
                  </div>
                </div>
              ) : (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`whitespace-nowrap px-2.5 py-2 text-sm font-medium rounded-md transition-colors hover:bg-secondary ${
                    location.pathname.replace(/\/?$/, "/") === item.href ? "text-primary" : "text-secondary"
                  }`}
                >
                  {item.label}
                </Link>
              ),
            )}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link to="/book-demo/">
              <Button size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground">
                Book Demo
              </Button>
            </Link>
          </div>

          <button
            className="lg:hidden p-2 inline-flex items-center justify-center text-foreground flex-shrink-0"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>

        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border/60 surface-elevated">
          <div className="container py-4 flex flex-col gap-2">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="px-3 py-2 text-sm font-medium rounded-md text-secondary hover:bg-secondary"
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="https://formiti.com"
              className="ml-4 px-3 py-2 text-sm font-medium rounded-md text-secondary hover:bg-secondary"
            >
              Formiti
            </a>
            <div className="flex gap-3 mt-4 pt-4 border-t border-border/60">
              <Link to="/book-demo/" className="flex-1" onClick={() => setOpen(false)}>
                <Button size="sm" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground">Book Demo</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
